import { atom } from 'recoil';
import { MealPickUpType } from '~/types';

const mealPickupType = atom<MealPickUpType>({
  key: 'mealPickupType',
  default: MealPickUpType.DELIVERY,
});

export default mealPickupType;
